import s from './style.module.scss';
import GrtImage from '@/components/GrtImage';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';

import CourseDetail from './CourseDetail';
import ChoseCourse from './ChoseCourse';
import { handleClickLearn } from '@/utils/Page/courseRecommend';
import img from '@/assets/images/mobile/course_recomend.webp';
import { RightOutline } from 'antd-mobile-icons';
import AllCourseList from './AllCourseList';
import { showPopup, hidePopup } from '@/utils/Page/modal';
import { handleGetcourseDetail } from '@/api/grt/courseCommend';
import ToastUtils from '@/utils/ToastUtils';
const MobileCourseRecommend = (props) => {
    const modalName = {
        all: 'allList',
        detail: 'detail',
        chose: 'choseList'
    };
    const [isLoading, setIsLoading] = useState(true);
    let { data = [], loading = false, description = '' } = props.recommend_course_result;

    //关闭多项目选择
    const closeChose = () => {
        hidePopup(modalName.chose);
    };
    //点击立即学习
    const clickLearn = async (id) => {
        let list = await handleClickLearn(id, 'mobile');
        //多项目选择
        if (list) {
            showPopup(<ChoseCourse list={list} resource_id={id} onClose={closeChose}></ChoseCourse>, {}, modalName.chose);
        }
    };
    //    关闭全部
    const closeAll = () => {
        hidePopup(modalName.all);
    };
    //打开全部
    const showAll = () => {
        showPopup(<AllCourseList data={data} clickLearn={clickLearn} onClose={closeAll} viewDetail={viewDetail}></AllCourseList>, {}, modalName.all);
    };
    //关闭详情
    const closeDetail = () => {
        hidePopup(modalName.detail);
    };
    const returnAllList = () => {
        closeDetail();
        if (!window[modalName.all]) {
            showAll();
        }
    };
    //点击查看详情
    const viewDetail = async (data, len) => {
        let res = await handleGetcourseDetail({ resource_id: data?.id });
        if (res && res.success && res.data) {
            res.data.resource_id = data?.id;
            res.data.resource_name = data?.title;
            showPopup(
                <CourseDetail
                    detail={res?.data}
                    allLen={len}
                    clickLearn={clickLearn}
                    returnAllList={returnAllList}
                    onClose={closeDetail}
                ></CourseDetail>,
                {},
                modalName.detail
            );
        } else {
            ToastUtils.showAbnormalToast(res?.msg || '操作失败');
        }
    };
    useEffect(() => {
        setIsLoading(false);
    }, []);
    return (
        <>
            <div className={s['box-wrap']}>
                <Display show={!loading}>
                    <>
                        <div className={s['tip']}>{description}</div>

                        <Display show={data.length > 0}>
                            <div className={s['border']}></div>
                            <div className={s['title']}>
                                <div className={s['left']}>
                                    <img src={img} alt="" />
                                    课程推荐
                                </div>
                                <Display show={data.length > 2}>
                                    <div onClick={showAll} className={s['right']}>
                                        查看全部
                                        <RightOutline />
                                    </div>
                                </Display>
                            </div>
                            <div className={s['list-wrap']}>
                                {data.slice(0, 2).map((ele, index) => {
                                    return (
                                        <div key={index} className={s['list-item']}>
                                            <GrtImage src={ele?.image_url}></GrtImage>
                                            <div className={s['info-wrap']}>
                                                <div className={s['course-title']}>{ele.title}</div>
                                                <div className={s['list-action']}>
                                                    <span
                                                        className={s['action-button']}
                                                        onClick={() => {
                                                            viewDetail(ele, data.length);
                                                        }}
                                                    >
                                                        查看详情
                                                    </span>
                                                    <span
                                                        data-type={'primary'}
                                                        onClick={() => {
                                                            clickLearn(ele.id);
                                                        }}
                                                        className={s['action-button']}
                                                    >
                                                        立即学习
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </Display>
                    </>
                </Display>

                <Display show={loading}>
                    <>
                        <div data-text="正在搜索相关课程" className="loading-text">
                            正在搜索相关课程
                        </div>
                    </>
                </Display>
            </div>
        </>
    );
};

export default MobileCourseRecommend;
